/* tslint:disable */
/* eslint-disable */
/**
 * BROStar API
 * Simplify the data management of the BRO
 *
 * The version of the OpenAPI document: v1
 * Contact: servicedesk@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface FieldMeasurement
 */
export interface FieldMeasurement {
  /**
   *
   * @type {string}
   * @memberof FieldMeasurement
   */
  readonly uuid?: string;
  /**
   *
   * @type {Date}
   * @memberof FieldMeasurement
   */
  readonly created?: Date;
  /**
   *
   * @type {Date}
   * @memberof FieldMeasurement
   */
  readonly updated?: Date;
  /**
   *
   * @type {number}
   * @memberof FieldMeasurement
   */
  parameter: number;
  /**
   *
   * @type {string}
   * @memberof FieldMeasurement
   */
  unit?: string | null;
  /**
   *
   * @type {string}
   * @memberof FieldMeasurement
   */
  fieldMeasurementValue?: string | null;
  /**
   *
   * @type {FieldMeasurementQualityControlStatusEnum}
   * @memberof FieldMeasurement
   */
  qualityControlStatus?: FieldMeasurementQualityControlStatusEnum | null;
  /**
   *
   * @type {string}
   * @memberof FieldMeasurement
   */
  gar: string;
  /**
   *
   * @type {string}
   * @memberof FieldMeasurement
   */
  dataOwner: string;
}

/**
 * @export
 */
export const FieldMeasurementQualityControlStatusEnum = {
  Afgekeurd: "afgekeurd",
  Goedgekeurd: "goedgekeurd",
  Onbeslist: "onbeslist",
  Onbekend: "onbekend",
} as const;
export type FieldMeasurementQualityControlStatusEnum =
  (typeof FieldMeasurementQualityControlStatusEnum)[keyof typeof FieldMeasurementQualityControlStatusEnum];

/**
 * Check if a given object implements the FieldMeasurement interface.
 */
export function instanceOfFieldMeasurement(value: object): value is FieldMeasurement {
  if (!("parameter" in value) || value["parameter"] === undefined) return false;
  if (!("gar" in value) || value["gar"] === undefined) return false;
  if (
    (!("dataOwner" in (value as Record<string, any>)) &&
      !("data_owner" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["dataOwner"] === undefined &&
      (value as Record<string, any>)["data_owner"] === undefined)
  )
    return false;
  return true;
}

export function FieldMeasurementFromJSON(json: any): FieldMeasurement {
  return FieldMeasurementFromJSONTyped(json, false);
}

export function FieldMeasurementFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FieldMeasurement {
  if (json == null) {
    return json;
  }
  return {
    uuid: json["uuid"] == null ? undefined : json["uuid"],
    created: json["created"] == null ? undefined : new Date(json["created"]),
    updated: json["updated"] == null ? undefined : new Date(json["updated"]),
    parameter: json["parameter"],
    unit: json["unit"] === undefined ? undefined : json["unit"] === null ? null : json["unit"],
    fieldMeasurementValue:
      json["field_measurement_value"] === undefined
        ? undefined
        : json["field_measurement_value"] === null
        ? null
        : json["field_measurement_value"],
    qualityControlStatus:
      json["quality_control_status"] === undefined
        ? undefined
        : json["quality_control_status"] === null
        ? null
        : json["quality_control_status"],
    gar: json["gar"],
    dataOwner: json["data_owner"],
  };
}

export function FieldMeasurementToJSON(json: any): FieldMeasurement {
  return FieldMeasurementToJSONTyped(json, false);
}

export function FieldMeasurementToJSONTyped(
  value?: Omit<FieldMeasurement, "uuid" | "created" | "updated"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    parameter: value["parameter"],
    unit: value["unit"],
    field_measurement_value: value["fieldMeasurementValue"],
    quality_control_status: value["qualityControlStatus"],
    gar: value["gar"],
    data_owner: value["dataOwner"],
  };
}
